import React from "react";
import { Container } from "@mui/material";
import SalesOrderAlerts from "./SalesOrderAlerts";

const Dashboard = () => {
	return (
		<Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 4, sm: 6, md: 8 } }}>
			<SalesOrderAlerts />
		</Container>
	);
};

export default Dashboard;
